import { UserGroupClient } from '@frontend/group/api';
import { SettingKey } from '@frontend/setting/types';
import type { Setting } from '@frontend/setting/types';
import { TransactionUserType } from '@frontend/transaction/types';
import type { TransactionUser } from '@frontend/transaction/types';
import type { IUser } from '@frontend/user/types';

const createSenderDraft = (userId: string, accountId: string, transactionId?: string): Partial<TransactionUser> => {
    const timestamp = new Date().toISOString();
    return {
        user_id: userId,
        type: TransactionUserType.SENDER,
        transaction_id: transactionId || '',
        account_id: accountId,
        creation_timestamp: timestamp,
        update_timestamp: timestamp
    };
};

/**
 * Returns a sender draft when the user is a member of the open drop-off senders group; otherwise null.
 */
export const resolveCourierSender = async (
    user: IUser,
    settings: Setting[] | undefined | null,
    accountId: string,
    transactionId?: string
): Promise<Partial<TransactionUser> | null> => {
    const groupId = settings?.find((setting) => setting.key === SettingKey.OPEN_DROP_OFF_SENDERS_USER_GROUP_ID)?.value;
    if (!groupId || typeof groupId !== 'string') {
        return null;
    }

    const membersResponse = await UserGroupClient.fetchUserGroupMembers({
        group_id: groupId,
        entity_id: user.id
    });

    if (membersResponse.results.length === 0) {
        return null;
    }

    return createSenderDraft(user.id, accountId, transactionId);
};
